'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/switch/style/css');

var _switch = require('antd/lib/switch');

var _switch2 = _interopRequireDefault(_switch);

var _css2 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _css3 = require('antd/lib/radio/style/css');

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _currency_input = require('./currency_input');

var _currency_input2 = _interopRequireDefault(_currency_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroup = _radio2.default.Group; /**
                                         * 商品运费设置组件
                                         */

var Option = _select2.default.Option;

var currencyWrapperStyle = {
    position: 'relative',
    top: '8px',
    display: 'inline-block'
};
var ShipInput = _react2.default.createClass({
    displayName: 'ShipInput',
    getInitialState: function getInitialState() {
        /**
         * 默认运费设置：
         * 上门自提、快递物流、同城速配都勾选
         * 上门自提只能0元
         * 快递物流和同城速配默认选择统一运费，默认运费0元
         */
        return {
            settings: [{
                type: '上门自提',
                checked: true
            }, {
                type: '快递物流',
                checked: true,
                price: {
                    type: '统一运费',
                    money: '0.00',
                    template: ''
                }
            }, {
                type: '同城速配',
                checked: true,
                price: {
                    type: '统一运费',
                    money: '0.00',
                    template: ''
                }
            }]
        };
    },
    onSwitchChange: function onSwitchChange(index, checked) {
        var settings = Object.assign({}, this.state.settings);
        settings[index].checked = checked;
        this.triggerChange({
            settings: settings
        });
    },
    onRadioChange: function onRadioChange(index, e) {
        var settings = Object.assign({}, this.state.settings);
        settings[index].price.type = e.target.value;
        this.triggerChange({
            settings: settings
        });
    },
    onInputChange: function onInputChange(index, event) {
        var settings = Object.assign({}, this.state.settings);
        settings[index].price.money = event.target.value;
        this.triggerChange({
            settings: settings
        });
    },
    onSelectChange: function onSelectChange(index, value) {
        var settings = Object.assign({}, this.state.settings);
        settings[index].price.template = value;
        this.triggerChange({
            settings: settings
        });
    },
    triggerChange: function triggerChange(changedValue) {
        // Should provide an event to pass value to Form.
        var onChange = this.props.onChange;
        if (onChange) {
            onChange(Object.assign({}, this.state, changedValue));
        }
    },
    componentDidMount: function componentDidMount() {
        this.triggerChange({
            settings: this.state.settings
        });
    },
    render: function render() {
        var settings = this.state.settings;

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    null,
                    '\u4E0A\u95E8\u81EA\u63D0'
                ),
                _react2.default.createElement(_switch2.default, { checkedChildren: '开', unCheckedChildren: '关', style: { marginRight: 10, marginLeft: 10 }, onChange: this.onSwitchChange.bind(this, 0), checked: settings[0].checked })
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    null,
                    '\u5FEB\u9012\u7269\u6D41'
                ),
                _react2.default.createElement(_switch2.default, { checkedChildren: '开', unCheckedChildren: '关', style: { marginRight: 10, marginLeft: 10 }, onChange: this.onSwitchChange.bind(this, 1), checked: settings[1].checked }),
                _react2.default.createElement(
                    RadioGroup,
                    { onChange: this.onRadioChange.bind(this, 1), disabled: !settings[1].checked, value: settings[1].price.type },
                    _react2.default.createElement(
                        _radio2.default,
                        { value: '\u7EDF\u4E00\u8FD0\u8D39' },
                        _react2.default.createElement(
                            'span',
                            null,
                            '\u7EDF\u4E00\u8FD0\u8D39\xA0\xA0'
                        ),
                        _react2.default.createElement(
                            'div',
                            { style: currencyWrapperStyle },
                            _react2.default.createElement(_currency_input2.default, { min: 0, onChange: this.onInputChange.bind(this, 1), disabled: !settings[1].checked || settings[1].price.type !== '统一运费', value: settings[1].price.money })
                        )
                    ),
                    _react2.default.createElement(
                        _radio2.default,
                        { value: '\u8FD0\u8D39\u6A21\u7248' },
                        '\u8FD0\u8D39\u6A21\u7248\xA0\xA0',
                        _react2.default.createElement(
                            _select2.default,
                            { placeholder: '\u8BF7\u9009\u62E9\u8FD0\u8D39\u6A21\u7248', onChange: this.onSelectChange.bind(this, 1), disabled: !settings[1].checked || settings[1].price.type !== '运费模版', value: settings[1].price.template },
                            _react2.default.createElement(
                                Option,
                                { value: 'jack' },
                                'Jack'
                            ),
                            _react2.default.createElement(
                                Option,
                                { value: 'lucy' },
                                'Lucy'
                            ),
                            _react2.default.createElement(
                                Option,
                                { value: 'disabled', disabled: true },
                                'Disabled'
                            ),
                            _react2.default.createElement(
                                Option,
                                { value: 'Yiminghe' },
                                'yiminghe'
                            )
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    null,
                    '\u540C\u57CE\u901F\u914D'
                ),
                _react2.default.createElement(_switch2.default, { checkedChildren: '开', unCheckedChildren: '关', style: { marginRight: 10, marginLeft: 10 }, onChange: this.onSwitchChange.bind(this, 2), checked: settings[2].checked }),
                _react2.default.createElement(
                    RadioGroup,
                    { onChange: this.onRadioChange.bind(this, 2), disabled: !settings[2].checked, value: settings[2].price.type },
                    _react2.default.createElement(
                        _radio2.default,
                        { value: '\u7EDF\u4E00\u8FD0\u8D39' },
                        '\u7EDF\u4E00\u8FD0\u8D39\xA0\xA0',
                        _react2.default.createElement(
                            'div',
                            { style: currencyWrapperStyle },
                            _react2.default.createElement(_currency_input2.default, { min: 0, onChange: this.onInputChange.bind(this, 2), disabled: !settings[2].checked || settings[2].price.type !== '统一运费', value: settings[2].price.money })
                        )
                    ),
                    _react2.default.createElement(
                        _radio2.default,
                        { value: '\u8FD0\u8D39\u6A21\u7248' },
                        '\u8FD0\u8D39\u6A21\u7248\xA0\xA0',
                        _react2.default.createElement(
                            _select2.default,
                            { placeholder: '\u8BF7\u9009\u62E9\u8FD0\u8D39\u6A21\u7248', onChange: this.onSelectChange.bind(this, 2), disabled: !settings[2].checked || settings[2].price.type !== '运费模版', value: settings[2].price.template },
                            _react2.default.createElement(
                                Option,
                                { value: 'jack' },
                                'Jack'
                            ),
                            _react2.default.createElement(
                                Option,
                                { value: 'lucy' },
                                'Lucy'
                            ),
                            _react2.default.createElement(
                                Option,
                                { value: 'disabled', disabled: true },
                                'Disabled'
                            ),
                            _react2.default.createElement(
                                Option,
                                { value: 'Yiminghe' },
                                'yiminghe'
                            )
                        )
                    )
                )
            )
        );
    }
});

exports.default = ShipInput;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/ship_input.js
// module id = 1483
// module chunks = 0